<template>
  <div class="reset-pwd-wrap">
    <div class="go-back" @click="goBack"></div>
    <div class="content-wrap flex-box flex-column space-center">
      <img src="../../assets/icon/email-icon.png" class="email-icon" alt="">
      <p class="title">邮箱验证</p>
      <p class="title2">输入我们发送到的验证码</p>
      <p class="email">{{email}}</p>
      <p class="text">输入您的6位数安全码</p>

      <div class="relative code-wrap">
        <ul
          class="relative flex-box"
          @click="focusInput">
          <li
            :class="{
              'code-focus': isFocus && code.length < 6,
              'error': inputError
            }"
            class="input-wrap flex-1 flex-box">
            <span
              v-for="index in 6"
              :class="{
                'custom-cursor': isFocus && ((code[index - 2] && !code[index - 1]) || (index === 1 && !code[0]))
              }"
              :key="index - 1">
              {{ code[index - 1] }}
            </span>
          </li>

          <li
            v-if="inputError"
            class="common-input-error">
            {{ inputError }}
          </li>
        </ul>

        <input
          :value="code"
          maxlength="6"
          ref="real-input"
          class="real-input"
          @input="input"
          @focus="focusInput(false)"
          @blur="isFocus = false; $emit('blur');" />
      </div>
      <el-button type="primary" class="submit" @click="submit()" :disabled="isDisable">提交</el-button>
    </div>
  </div>
</template>

<script>
import {sendcode, register} from '../../request/api'
export default {
  name: 'CommonCodeInput',
  props: {
    inputError: String // input错误信息
  },
  data () {
    return {
      isFocus: false,
      focus: true,
      value: '',
      isDisable: true,
      email: ''
    }
  },
  computed: {
    code: {
      get () {
        return this.value
      },
      set (v) {
        this.code = v
      }
    }
  },
  watch: {
    focus (v) {
      if (v) {
        this.focusInput()
      }
    }
  },
  created () {
    this.email = this.$route.query.email || this.$store.state.signInfo.email || localStorage.getItem('email')
    sendcode({email: this.email}).then(() => {
      this.$message.success('发送成功')
    }).catch(err => {
      this.$message.error(err)
    })
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    submit () {
      if (this.$route.query.email) {
        this.$store.dispatch('setCode', {code: this.code})
        this.$router.push({
          path: '/reset_pwd',
          query: {
            email: this.$route.query.email
          }
        })
      } else {
        register({...this.$store.state.signInfo, code: this.code}).then(() => {
          this.$message.success('跳转登录')
          this.$router.replace('/login')
        }).catch(err => {
          this.$message.error(err)
        })
      }
    },
    input (el) {
      let value = el.target.value
      value = value.replace(/[^\d]/g, '')
      this.value = value
      if (this.value.length >= 6) {
        this.isDisable = false
      } else {
        this.isDisable = true
      }
    },
    focusInput () {
      this.isFocus = true
      this.$refs['real-input'] && this.$refs['real-input'].focus()
      this.$emit('update:input-error', '')
      this.$emit('update:error-msg', '')
      this.$emit('focus')
    }
  }
}
</script>

<style scoped lang="scss">
.reset-pwd-wrap {

  width: 1139px;
  margin: 16px auto 0;
  min-height: calc(100vh - 87px);

  .go-back {
    width: 29px;
    height: 29px;
    background: url('../../assets/icon/back-icon.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .content-wrap {
    margin-top: 27px;
    .email-icon {
      width: 132px;
      height: 102px;
    }
    .title {
      margin-top: 21px;
      color: #333333;
      font-size: 24px;
      font-weight: bold;
    }
    .title2 {
      color: #666666;
      margin-top: 6px;
      font-size: 20px;
    }
    .email {
      font-size: 24px;
      color: #333333;
      margin-top: 6px;
      font-weight: bold;
    }
    .text {
      width: 486px;
      margin-top: 40px;
      margin-bottom: 20px;
      font-size: 20px;
      color: #333;
    }
    .submit {
      margin-top: 48px;
    }
  }
  .input-wrap {
    border-radius: 4px;
    overflow: hidden;
    span:not(:last-child) {
      margin-right: 18px;
    }
    border-color: #E3E8ED;

    &.error {
      border-color: #FF4444;
    }

    &.code-focus {
      border-color: #4EABF9;

      &.error {
        border-color: #FF4444;
      }
    }

    span {
      width: 64px;
      height: 64px;
      line-height: 64px;
      border-radius: 10px;
      background: #E3E8ED;
      display: inline-block;
      text-align: center;
      font-size: 24px;
      font-weight: 500;
      color: #666666;
      border: 1px solid transparent;
    }

    .custom-cursor {
      position: relative;
      border: 1px solid #4EABF9;
      &::after {
        content: '';
        position: absolute;
        width: 1px;
        height: 30px;
        left: calc(50% - 0.5px);
        top: calc(50% - 15px);
      }
    }
  }

  .common-input-error {
    position: absolute;
    left: 0;
    top: calc(100% + 8px);
    text-align: center;
    font-size: 12px;
    width: 100%;
  }

  .real-input {
    position: absolute;
    z-index: -999;
    left: 0;
    top: 0;
    opacity: 0;
  }

}
</style>
